export default function TextField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  maxLength,
  ...props
}) {
  const computedClassName = [
    "form-group",
    "text-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <input
        id={id}
        name={name}
        type="text"
        value={value || ""}
        maxLength={maxLength}
        className="form-control"
        onChange={onChange}
        aria-invalid={isInvalid}
        disabled={disabled}
      />
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

TextField.defaultProps = {
  className: "",
  onChange: (event) => {},
  value: "",
};
